export default __webpack_public_path__ + "static/media/ttu.2510257f.png";